export default "__VITE_ASSET__CmdaKVsP__"